import { inject } from '@angular/core'
import { SavedSearchService } from 'src/app/services/saved-search.service'

export class BaseDisplayComponent {

    public attributeOrder = [ 'Situation Types', 'Industries', 'Story Sources', 'Story Types', 'reason']

    protected savedSearchService = inject(SavedSearchService)

    attributeNameToColour(name: string): string {
        let result = 'btn-bankruptcydata'
        switch (name) {
            case 'Industries':
                result = 'btn-teal-gradient'
                break
            case 'Situations':
                result = 'btn-gradient'
                break
            case 'Situation Type':
                result = 'btn-blue-bankruptcydata'
                break
            case 'Story Sources':
                result = 'btn-blue-gradient'
                break
        }
        return 'btn btn-sm ' + result
    }

    attributeClick(event: Event, name: string, value: string) {

        if (name === 'Situation Types') {
            name = 'Situations'
        }
        event.stopPropagation()
        this.savedSearchService.loadSearch({
            parameters: {
                [name]: {
                    type: 'checkboxes',
                    name,
                    value: [value]
                }
            }
        })
    }

    removeDate(content: string): string {
        return content.replace(/^[A-Za-z]{3,} \d+, \d+ – /, '')
    }

    splitTitle(content: string): string {
        let parts = content.split(' – ')
        const name = parts.shift()
        return `<strong>${name}</strong><br>${parts.join(' -')}`
    }

}